import React from 'react';

export enum LeaderboardId {
  Runs = 'runs',
  Compare = 'compare',
  Reports = 'reports',
  MyRuns = 'my-runs',
}

export type LeaderboardContextType = Readonly<{
  /** arbitrary value created on FE side that identifies context scope */
  id: LeaderboardId | `${LeaderboardId}-${string}`;
  /** value that uniquely identifies the entity. It can be **UUID** ot **qualified id** */
  entityId: string;
  entityType: string;
  types: string[];
  isArchived: boolean;
  experimentsOnly: boolean;
}>;

export const LeaderboardContext = React.createContext<LeaderboardContextType>({
  get id(): LeaderboardContextType['id'] {
    throw new Error('LeaderboardContext is uninitialized here.');
  },
  get entityId(): string {
    throw new Error('LeaderboardContext is uninitialized here.');
  },
  get entityType(): LeaderboardContextType['entityType'] {
    throw new Error('LeaderboardContext is uninitialized here.');
  },
  get types(): LeaderboardContextType['types'] {
    throw new Error('LeaderboardContext is uninitialized here.');
  },
  get isArchived(): LeaderboardContextType['isArchived'] {
    throw new Error('LeaderboardContext is uninitialized here.');
  },
  get experimentsOnly(): LeaderboardContextType['experimentsOnly'] {
    throw new Error('LeaderboardContext is uninitialized here.');
  },
});
